import MUIDialog, {
  type DialogProps as MUIDialogProps,
} from '@mui/material/Dialog';

export interface DialogProps extends MUIDialogProps {
  // biome-ignore lint/complexity/noBannedTypes: Needed to mock the onClose prop
  onClose?: ((event: {}, reason: 'escapeKeyDown') => void) | undefined;
}

export function Dialog({ onClose, ...props }: DialogProps) {
  return (
    <MUIDialog
      {...props}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') return;
        onClose?.(event, reason);
      }}
    />
  );
}
